export interface MembershipPlan {
    id: 'monthly' | 'annual';
    label: string;
    priceCents: number;
    cadenceLabel: string;
    /** Savings badge vs 12× monthly, in whole dollars; null for monthly or when not positive. */
    savingsDollars: number | null;
}

/**
 * Display metadata is local; PRICES come from GET /api/membership/plans
 * (env-overridable server-side — see useMembershipPlans). These fallbacks
 * render only until the fetch resolves and must match the server defaults.
 * Never hardcode a membership price anywhere else in the dashboard.
 */
export const FALLBACK_MEMBERSHIP_PLANS: MembershipPlan[] = [
    {id: 'monthly', label: 'Monthly Plan', priceCents: 4900, cadenceLabel: 'per month', savingsDollars: null},
    {id: 'annual', label: 'Annual Plan', priceCents: 47000, cadenceLabel: 'per year', savingsDollars: 118},
];

/** Merge server prices over the local display metadata; savings is computed. */
export function buildMembershipPlans(server: Array<{id: string; amount_cents: number}>): MembershipPlan[] {
    const priceById = new Map(server.map((p) => [p.id, p.amount_cents]));
    const merged = FALLBACK_MEMBERSHIP_PLANS.map((plan) => ({
        ...plan,
        priceCents: priceById.get(plan.id) ?? plan.priceCents,
    }));
    const monthly = merged.find((p) => p.id === 'monthly');
    return merged.map((plan) => {
        if (plan.id !== 'annual' || !monthly)
            return {...plan, savingsDollars: plan.id === 'annual' ? plan.savingsDollars : null};
        const savings = Math.round((monthly.priceCents * 12 - plan.priceCents) / 100);
        return {...plan, savingsDollars: savings > 0 ? savings : null};
    });
}
